<template lang="pug">
  v-row
    v-col
      .d-flex
        h1(class="mb-4 ml-3") Вебинары
        v-spacer
        v-btn(
          v-if="isTeacher || isOrganization"
          :to="{ name: 'WebinarCreate' }"
          color="success"
          rounded depressed
        )
          v-icon mdi-plus
          span.ml-2.d-none.d-sm-block Добавить вебинар
      v-row(class="search-block mx-0")
        v-col(cols=12 sm=6 md=4)
          v-text-field(
            label="Название"
            v-model="searchName"
            hide-details clearable rounded filled
          )
        v-col(cols=12 sm=6 md=4)
          activity-select(
            v-model="searchActivity"
            :options="{ hideDetails: true, itemValue: 'name' }"
          )
        v-col(cols=12 md=4)
          v-select(
            label="Сортировка"
            v-model="sort"
            :items="sortItems"
            item-value="id"
            hide-details clearable rounded filled
          )
      v-row
        v-col(v-if="loading" v-for="n in 6" xl="3" lg="4" md="6" cols="12"  :key="`sl${n}`")
          v-skeleton-loader(
            class="mx-auto"
            type="article, actions"
          )
        v-col(
          v-for="webinar in webinars"
          :key="webinar.id"
          class="webinar-tile"
          cols="12" sm="6" md="4" lg="4" xl="4"
        )
          webinar-card(
            :webinar="webinar"
            @delete="openDeleteDialog"
          )
        v-slide-y-reverse-transition
          v-col(v-if="!loading && !webinars.length" class="text-center")
            span(class="grey--text") Вебинары отсутствуют

    delete-dialog(
      v-model="showDeleteDialog"
      @delete="deleteWebinar"
    )
      template(v-slot:body) Вы действительно хотите удалить данный вебинар?

</template>

<script>
import { mapGetters } from 'vuex';
import _debounce from 'lodash/debounce';
import anime from 'animejs';

import WebinarService from '@/services/API/WebinarService';
import WebinarCard from '@/modules/Webinars/components/WebinarCard.vue';
import ActivitySelect from '@/components/InputFields/course/SelectActivity.vue';

export default {
  name: 'WebinarList',
  components: { ActivitySelect, WebinarCard },
  data: () => ({
    webinars: [],
    deleteId: null,
    showDeleteDialog: false,
    searchName: '',
    searchActivity: null,
    sort: null,
    sortItems: [
      { id: 'rating', text: 'По рейтингу' },
      { id: 'created_at', text: 'Сначала старые' },
      { id: '-created_at', text: 'Сначала новые' },
    ],
    params: {},
    loading: true,
  }),
  computed: {
    ...mapGetters({ isTeacher: 'auth/isTeacher', isOrganization: 'auth/isOrganization' }),
  },
  watch: {
    searchActivity(val) {
      this.params['search[directory_activity]'] = val;
      this.getWebinars(this.params);
    },
    // eslint-disable-next-line func-names
    searchName: _debounce(function (val) {
      this.params['search[title]'] = val;
      this.getWebinars(this.params);
    }, 500),
    sort(val) {
      this.params.sort = val;
      this.getWebinars(this.params);
    },
  },
  mounted() {
    this.getWebinars();
  },
  methods: {
    getWebinars(params = {}) {
      this.$rHandler(
        WebinarService.getWebinarList(params),
        (r) => {
          this.webinars = r.data.data;
          this.loading = false;
          setTimeout(() => {
            anime({
              targets: '.webinar-tile',
              translateY: [100, 0],
              opacity: [0, 1],
              duration: 600,
              autoplay: true,
              easing: 'easeOutExpo',
              delay: anime.stagger(100),
            });
          }, 100);
        },
      );
    },
    openDeleteDialog(webinarId) {
      this.deleteId = webinarId;
      this.showDeleteDialog = true;
    },
    deleteWebinar() {
      this.$rHandler(
        WebinarService.deleteWebinar(this.deleteId),
        () => {
          this.webinars = this.webinars.filter((w) => w.id !== this.deleteId);
          this.deleteId = null;
          this.showDeleteDialog = false;
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-block {
    box-shadow: 0 8px 24px -19px rgba(0, 0, 0, 0.8);
    border: 1px solid #f5f5f5;
    background-color: #fff;
    border-radius: 8px;
  }

  .theme--dark .search-block {
    background-color: inherit;
    border: 1px solid #292929;
  }

  .webinar-tile {
    opacity: 0;
  }

</style>
